module.exports = {"title":"About","path":"/about/","body":"<p>Gatsby Static Site Sample. Shows how to use:</p>\n<ol>\n<li>Pages (see <code>pages/pages/about.md</code>)</li>\n<li>Posts (see <code>pages/posts/*.md</code>)</li>\n<li>Custom Content Types (see <code>data/links.js</code>)</li>\n</ol>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./pages/about.md
 ** module id = 380
 ** module chunks = 0
 **/